/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTrackedPublisherRequest } from '../../models/create-tracked-publisher-request';
import { TrackedPublisher } from '../../models/tracked-publisher';

export interface CreateTrackedPublisher$Params {
      body: CreateTrackedPublisherRequest
}

export function createTrackedPublisher(http: HttpClient, rootUrl: string, params: CreateTrackedPublisher$Params, context?: HttpContext): Observable<StrictHttpResponse<TrackedPublisher>> {
  const rb = new RequestBuilder(rootUrl, createTrackedPublisher.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TrackedPublisher>;
    })
  );
}

createTrackedPublisher.PATH = '/v0/publishers';
